import { Timer, SignOut } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export const SessionExpiryDialog = ({ seconds, onStay, onLogout }) => {
  const mm = String(Math.floor(seconds / 60)).padStart(1, "0");
  const ss = String(seconds % 60).padStart(2, "0");
  return (
    <Dialog open onOpenChange={(open) => { if (!open) onStay(); }}>
      <DialogContent data-testid="session-expiry-dialog" className="bg-zinc-950 border-amber-500/40 text-zinc-100 sm:max-w-md"
        onEscapeKeyDown={(e) => e.preventDefault()} onPointerDownOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-300">
            <Timer size={22} weight="duotone" /> Sua sessão vai expirar
          </DialogTitle>
          <DialogDescription className="text-zinc-400">
            Por segurança, a sessão é encerrada após um período sem atividade. Clique em continuar para não perder o que está fazendo.
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center justify-center py-2">
          <span data-testid="session-expiry-countdown" className="font-mono text-5xl font-semibold tabular-nums text-amber-300">
            {mm}:{ss}
          </span>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 sm:justify-end">
          <button data-testid="session-expiry-logout" onClick={onLogout}
            className="inline-flex items-center justify-center gap-2 border border-zinc-700 hover:bg-zinc-800 text-zinc-300 text-sm font-medium px-4 py-2.5 rounded transition-colors">
            <SignOut size={16} /> Sair agora
          </button>
          <button data-testid="session-expiry-continue" onClick={onStay} autoFocus
            className="inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 text-zinc-950 text-sm font-semibold px-5 py-2.5 rounded transition-colors">
            Continuar logada
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
